module.exports = __webpack_public_path__ + "static/img/team.342679e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team.png
// module id = QyPm
// module chunks = 36